import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"
import Stack from "@mui/material/Stack"

import { OnboardingPageProps } from "../first-time-onboarding.types"

import Image from "@components/image"

const OnboardingPage = ({
  title,
  image,
  body,
  alt,
  ctas,
}: OnboardingPageProps) => {
  return (
    <Box
      display="grid"
      gap={7}
      sx={{
        gridTemplateRows: { xs: "0.8fr 1fr 1fr", sm: "1fr 0.5fr 1fr" },
        margin: "72px 36px 36px 36px",
        height: { xs: "100%", sm: "80%" },
      }}
    >
      <Box alignItems={"center"} justifyContent={"center"} display={"flex"}>
        <Typography
          variant="h4"
          sx={(theme) => ({ color: theme.palette.primary.main })}
        >
          {title}
        </Typography>
      </Box>
      <Box alignItems={"center"} justifyContent={"center"} display={"flex"}>
        {image ? <Image src={image} alt={alt} /> : null}
      </Box>
      <Box>
        <Typography>{body}</Typography>
        {ctas ? (
          <Stack spacing={3} sx={{ minWidth: "100%" }}>
            {ctas.map((cta, i) => (
              <Button key={i} {...cta}>
                {cta.text}
              </Button>
            ))}
          </Stack>
        ) : null}
      </Box>
    </Box>
  )
}

export default OnboardingPage
